// extracted by mini-css-extract-plugin
export default {"clipboard":"ClipboardButton_clipboard__gBTXR","feedback":"ClipboardButton_feedback__bY-rR","button":"ClipboardButton_button__f2iRZ"};